export default {
    domain: 'dev-w4r0mvax.us.auth0.com',
    clientId: '2aQBXFRPyZ9iiMi9bh3vQ5jVmmIPLCWT',
    redirectUri: window.location.origin,
    cacheLocation: 'localstorage'
}